/**
 * 全 img 要素に data-is-liquid="true" を付与する。
 * CSS 側ですべての img の width 基本値を 100% としたいが、
 * 一部個別で width 属性値指定したい状況も想定し、
 * CSS で直接 img { width: 100% } と定義してしまうと、属性値では上書きできなくなるため
 *（例え utility クラスで width: auto に上書きをしたとしても、auto プロパティから
 * 画像の原寸サイズ計算がされて原寸表示がされるだけなので、Retina 画像には対応できない）、
 * 全 img の DOM を拾ってデフォルトで data 属性を付与し、css 側で
 * img[data-is-liquid="true"]{ width: 100% } とし、
 * 個別で固定幅指定したい img に関しては <img data-is-liquid="false"> とすることで
 * Attribute Style を基本値にすることを実現する。
 *
 * @param image 探索対象の img 要素
 */
export function setLiquidOnImageTags(image: HTMLElement): void {
  const isLiquid = image.getAttribute('data-is-liquid')
  if (isLiquid == null || isLiquid === '') {
    image.setAttribute('data-is-liquid', 'true')
  }
}

/**
 * 全 form 要素に accept-charset 属性を付与する。
 * 予め accept-charset の値が指定されていない場合は、デフォルト値として「UTF-8」が指定される。
 *
 * @param form 探索対象の form 要素
 */
export function setAcceptCharsetOnFormTags(form: HTMLElement): void {
  const acceptCharset = form.getAttribute('accept-charset')
  if (acceptCharset == null || acceptCharset === '') {
    form.setAttribute('accept-charset', 'UTF-8')
  }
}
